/**
 * Constants for website environments.
 * NOTE: These are duplicated in next.config.js and should be kept in sync.
 */
const SITE_ENVIRONMENTS = {
  ACHIEVE: 'achieve',
  FDR: 'website-fdr',
  FFN: 'website-ffn',
  WFS: 'website-wfs',
  DEFAULT: 'achieve',
  BILLS: 'website-bills',
}

const WEBSITE_NAMES = {
  ACHIEVE: 'Achieve',
  FDR: 'Freedom Debt Relief',
  FFN: 'Freedom Financial Network',
  WFS: 'Weekly Financial Solutions',
  BILLS: 'Bills',
}

const PAGE_LIST = {
  default: {
    websiteField: WEBSITE_NAMES.ACHIEVE,
  },
  achieve: {
    websiteField: WEBSITE_NAMES.ACHIEVE,
  },
  'website-wfs': {
    websiteField: WEBSITE_NAMES.WFS,
  },
  'website-fdr': {
    websiteField: WEBSITE_NAMES.FDR,
  },
  'website-ffn': {
    websiteField: WEBSITE_NAMES.FFN,
  },
  'website-bills': {
    websiteField: WEBSITE_NAMES.BILLS,
  },
}

const WEBSITEFIELD_TO_HOST_MAP = {
  default: {
    host: 'https://www.achieve.com',
  },
  Achieve: {
    host: 'https://www.achieve.com',
  },
  'Weekly Financial Solutions': {
    websiteField: 'Weekly Financial Solutions',
    host: 'https://www.weeklyfinancialsolutions.com',
  },
  FDR: {
    websiteField: 'FDR',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Debt Relief': {
    websiteField: 'Freedom Debt Relief',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Financial Network': {
    websiteField: 'Freedom Financial Network',
    host: 'https://www.freedomfinancialnetwork.com',
  },
  Bills: {
    websiteField: 'Bills',
    host: 'https://www.bills.com',
  },
}

const FAVICON_FOLDER = {
  [SITE_ENVIRONMENTS.DEFAULT]: 'favicon-for-achieve',
  [SITE_ENVIRONMENTS.ACHIEVE]: 'favicon-for-achieve',
  [SITE_ENVIRONMENTS.FDR]: 'favicon-for-fdr',
  [SITE_ENVIRONMENTS.FFN]: 'favicon-for-ffn',
  [SITE_ENVIRONMENTS.WFS]: 'favicon-for-wfs',
  [SITE_ENVIRONMENTS.BILLS]: 'favicon-for-bills',
}

export { SITE_ENVIRONMENTS, PAGE_LIST, WEBSITEFIELD_TO_HOST_MAP, WEBSITE_NAMES, FAVICON_FOLDER }
export default SITE_ENVIRONMENTS
